import React, { useEffect, useRef } from 'react';
import _ from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { designActions } from '../../actions';
import { moveableBoarder } from '../VMoveable/utils';
import PropTypes from 'prop-types';
import './ZoomTool.css';
import { isMobileOnly } from 'react-device-detect';

const ZoomTool = props => {
  let { originWidth, originHeight, pagesCount } = props;
  const dispatch = useDispatch();
  const zoom = useSelector(state => state.design.scale);
  const holderSize = useRef();
  const pageSizes = useRef();
  const pageToolbars = useRef();
  const artboards = useRef();
  const pagePercent = isMobileOnly ? 96 : 80;

  let newSize = {};
  let firstScale;

  useEffect(() => {
    window.addEventListener('resize', onResize);

    return () => {
      window.removeEventListener('resize', onResize);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    holderSize.current = {
      w: document.getElementById('artboardHolder').offsetWidth,
      h: document.getElementById('artboardHolder').offsetHeight,
    };

    pageToolbars.current = document.getElementsByClassName('pageToolbar');
    pageSizes.current = document.getElementsByClassName('pageSize');
    artboards.current = document.getElementsByClassName('artboard');

    const artboard = _.get(artboards, 'current[0]', null);
    if ((!originWidth || !originHeight) && artboard) {
      originWidth = artboard.offsetWidth;
      originHeight = artboard.offsetHeight;
    }
    initSize();
    if (originWidth && originHeight) {
      document.addEventListener('keydown', onKeyDown);
      // document.addEventListener('keyup', onKeyUp);
      document.getElementById('root').addEventListener('wheel', wheelZoom, true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagesCount, originWidth, originHeight]);

  const onResize = () => {
    holderSize.current = {
      w: document.getElementById('artboardHolder').offsetWidth,
      h: document.getElementById('artboardHolder').offsetHeight,
    };

    pageToolbars.current = document.getElementsByClassName('pageToolbar');
    pageSizes.current = document.getElementsByClassName('pageSize');
    artboards.current = document.getElementsByClassName('artboard');

    const artboard = _.get(artboards, 'current[0]', null);
    if ((!originWidth || !originHeight) && artboard) {
      originWidth = artboard.offsetWidth;
      originHeight = artboard.offsetHeight;
    }
    initSize();
  };

  const onKeyDown = e => {
    if (e.ctrlKey && (e.keyCode === 61 || e.keyCode === 107 || e.keyCode === 187)) {
      e.preventDefault();
      zoomIn();
    }
    if (e.ctrlKey && (e.keyCode === 173 || e.keyCode === 109 || e.keyCode === 189)) {
      e.preventDefault();
      zoomOut();
    }
  };
  const wheelZoom = e => {
    if (e.ctrlKey) {
      e.preventDefault();
      if (e.deltaY < 0) {
        zoomIn();
      } else {
        zoomOut();
      }
    }
  };

  const initSize = () => {
    if (_.get(pageSizes, 'current.length', 0) > 0) {
      const artboardOrientation = originHeight > originWidth ? 'portrait' : 'landscape';
      const maxWidth = (holderSize.current.w * pagePercent) / 100;
      const maxHeight = (holderSize.current.h * pagePercent) / 100;

      if (artboardOrientation === 'landscape') {
        let newSizeW = maxWidth;
        let newSizeH = (newSizeW * originHeight) / originWidth;
        if (newSizeH > maxHeight) {
          newSizeH = maxHeight;
          newSizeW = (newSizeH * originWidth) / originHeight;
        }
        newSize = { w: newSizeW, h: newSizeH };
      } else {
        let newSizeH = maxHeight;
        let newSizeW = (newSizeH * originWidth) / originHeight;
        if (newSizeW > maxWidth) {
          newSizeW = maxWidth;
          newSizeH = (newSizeW * originHeight) / originWidth;
        }
        newSize = { w: newSizeW, h: newSizeH };
      }
      // if (pageOrientation === 'portrait') {
      // } else {
      //   if (artboardOrientation === 'landscape') {
      //     let newSizeH = (holderSize.current.h * pagePercent) / 100;
      //     let newSizeW = (newSizeH * originWidth) / originHeight;
      //     newSize = { w: newSizeW, h: newSizeH };
      //   } else {
      //     let newSizeW = (holderSize.current.w * pagePercent) / 100;
      //     let newSizeH = (newSizeW * originHeight) / originWidth;
      //     newSize = { w: newSizeW, h: newSizeH };
      //   }
      // }
      // if (originHeight >= originWidth) {
      //   if (originHeight !== holderSize.current.h) {
      //     let newSizeH = (holderSize.current.h * pagePercent) / 100;
      //     let newSizeW = (newSizeH * originWidth) / originHeight;
      //     newSize = { w: newSizeW, h: newSizeH };
      //   } else if (newSize.w >= holderSize.current.w) {
      //     let newSizeW = (holderSize.current.w * pagePercent) / 100;
      //     let newSizeH = (newSizeW * originHeight) / originWidth;
      //     newSize = { w: newSizeW, h: newSizeH };
      //   }
      // } else {
      //   if (originWidth !== holderSize.current.w) {
      //     let newSizeW = (holderSize.current.w * pagePercent) / 100;
      //     let newSizeH = (newSizeW * originHeight) / originWidth;
      //     newSize = { w: newSizeW, h: newSizeH };
      //   } else if (newSize.h >= holderSize.current.h) {
      //     let newSizeH = (holderSize.current.h * pagePercent) / 100;
      //     let newSizeW = (newSizeH * originWidth) / originHeight;
      //     newSize = { w: newSizeW, h: newSizeH };
      //   }
      // }

      if (!newSize.w) {
        firstScale = 1;
      } else {
        firstScale = newSize.w / originWidth;
      }
      Array.from(pageSizes.current).forEach(pageSize => {
        pageSize.style.width = newSize.w + 'px';
        pageSize.style.height = newSize.h + 'px';
      });
      Array.from(pageToolbars.current).forEach(pageToolbar => {
        pageToolbar.style.width = newSize.w + 'px';
      });
      Array.from(artboards.current).forEach(artboard => {
        artboard.style.transform = `scale(${firstScale})`;
      });

      moveableBoarder(Math.round(firstScale * 100));
      dispatch(designActions.changeDesignScale(Math.round(firstScale * 100)));
    }
  };

  const getScale = el => {
    let scale = 1;
    if (el) {
      let style = window.getComputedStyle(el);
      // eslint-disable-next-line no-undef
      let matrix = new WebKitCSSMatrix(style.webkitTransform);
      scale = Math.sqrt(matrix.a * matrix.a + matrix.b * matrix.b);
    }

    return scale;
  };

  let newScale, currentScale;

  const zoomIn = () => {
    const artboardTarget = _.get(artboards, 'current[0]', null);
    currentScale = getScale(artboardTarget);
    newScale = currentScale + 0.1;

    Array.from(pageSizes.current).forEach(pageSize => {
      pageSize.style.width = originWidth * newScale + 'px';
      pageSize.style.height = originHeight * newScale + 'px';
    });
    Array.from(pageToolbars.current).forEach(pageToolbar => {
      pageToolbar.style.width = originWidth * newScale + 'px';
    });
    Array.from(artboards.current).forEach(artboard => {
      artboard.style.transform = `scale(${newScale})`;
    });

    dispatch(designActions.changeDesignScale(Math.round(newScale * 100)));
    moveableBoarder(Math.round(newScale * 100));
  };

  const zoomOut = () => {
    const artboardTarget = _.get(artboards, 'current[0]', null);
    currentScale = getScale(artboardTarget);
    newScale = currentScale - 0.1;
    if (newScale < 0.05) {
      newScale = currentScale;
      return;
    }

    Array.from(pageSizes.current).forEach(pageSize => {
      pageSize.style.width = originWidth * newScale + 'px';
      pageSize.style.height = originHeight * newScale + 'px';
    });
    Array.from(pageToolbars.current).forEach(pageToolbar => {
      pageToolbar.style.width = originWidth * newScale + 'px';
    });
    Array.from(artboards.current).forEach(artboard => {
      artboard.style.transform = `scale(${newScale})`;
    });

    dispatch(designActions.changeDesignScale(Math.round(newScale * 100)));
    moveableBoarder(Math.round(newScale * 100));
  };

  return (
    <div className="zoomTool">
      <span onClick={zoomIn}>+</span>
      <span className="text">{zoom}%</span>
      <span onClick={zoomOut}>-</span>
    </div>
  );
};

ZoomTool.propTypes = {
  originWidth: PropTypes.number,
  originHeight: PropTypes.number,
  pagesCount: PropTypes.number,
};

export default ZoomTool;
